import React from 'react';
import { Descriptions } from 'antd';
import StatusTag from '../StatusTag';
import { STATUSES } from '../../constants/vacancyRequestColumnLabels';

const getBool = (v) => (v ? 'Да' : 'Нет');

const RequestGeneralInfoTab = ({ request, vacancies, organisations, users }) => {

    const getEntityName = (id, entities, key = 'name') => {
        const numericId = typeof id === 'string' ? parseInt(id) : id;
        const entity = entities?.find(e => e.organisation_id === numericId);
        return entity ? entity[key] : 'Не указано';
    };

    const getUserName = (id) => {
        const user = users?.find(u => u.id === id);
        return user ? `${user.first_name} ${user.last_name}` : 'Не указано';
    };

    const getDepartmentName = (departmentId, organisations) => {
        const org = organisations.find(o => o.organisation_id === request.organisation);
        const department = org?.departments?.find(d => d.id === departmentId);
        return department ? department.name : 'Не указано';
    };

    const renderObjectArray = (array, keyField, valueField) => {
        if (!Array.isArray(array)) return '—';
        return array.map((item, index) => (
            <div key={index}>
                {item[keyField]}: {item[valueField]}
            </div>
        ));
    };

    return (
        <div className="request-general-info">
            <Descriptions bordered column={1}>
                <Descriptions.Item label="ID заявки">{request.id}</Descriptions.Item>
                <Descriptions.Item label="Вакансия">{request.job_title}</Descriptions.Item>
                <Descriptions.Item label="Компания">
                    {getEntityName(request.organisation, organisations)}
                </Descriptions.Item>
                <Descriptions.Item label="Отдел">
                    {getDepartmentName(request.department, organisations)}
                </Descriptions.Item>
                <Descriptions.Item label="Автор">{getUserName(request.author)}</Descriptions.Item>
                <Descriptions.Item label="Статус">
                    {request.is_template ? <StatusTag status="template" statuses={STATUSES} /> : <StatusTag status={request.status} statuses={STATUSES} />}
                </Descriptions.Item>
                <Descriptions.Item label="Должность автора">{request.author_position || '—'}</Descriptions.Item>
                <Descriptions.Item label="Исполнитель">{getUserName(request.assignee_id)}</Descriptions.Item>
                <Descriptions.Item label="Дата создания">
                    {new Date(request.created_at).toLocaleDateString()}
                </Descriptions.Item>
                <Descriptions.Item label="Город">{request.city || '—'}</Descriptions.Item>
                <Descriptions.Item label="Пол">{request.gender || '—'}</Descriptions.Item>
                <Descriptions.Item label="Возраст">{request.age || '—'}</Descriptions.Item>
                <Descriptions.Item label="Семейное положение">
                    {Array.isArray(request.marital_status) ? request.marital_status.join(', ') : request.marital_status || '—'}
                </Descriptions.Item>
                <Descriptions.Item label="Количество позиций">{request.positions_count}</Descriptions.Item>
                <Descriptions.Item label="Причина вакансии">{request.vacancy_reason || '—'}</Descriptions.Item>
                <Descriptions.Item label="Планируемая дата выхода">{request.planned_start_date}</Descriptions.Item>
                <Descriptions.Item label="Зарплата на испытательный срок">{request.trial_salary || '—'}</Descriptions.Item>
                <Descriptions.Item label="Зарплата после испытательного срока">{request.post_trial_salary || '—'}</Descriptions.Item>
                <Descriptions.Item label="Ставка">{request.rate || '—'}</Descriptions.Item>
                <Descriptions.Item label="График работы">{request.work_schedule || '—'}</Descriptions.Item>
                <Descriptions.Item label="Время работы">
                    {request.work_start_time} – {request.work_end_time}
                </Descriptions.Item>
                <Descriptions.Item label="Адрес рабочего места">{request.workplace_address || '—'}</Descriptions.Item>
                <Descriptions.Item label="Дома/офисные условия">{request.field_vs_office || '—'}</Descriptions.Item>
                <Descriptions.Item label="Форма зарплаты">{request.salary_structure || '—'}</Descriptions.Item>
                <Descriptions.Item label="Компенсация телефона">{getBool(request.compensate_phone)}</Descriptions.Item>
                <Descriptions.Item label="Компенсация автомобиля">{getBool(request.compensate_car)}</Descriptions.Item>
                <Descriptions.Item label="Материальная ответственность">{getBool(request.is_material_responsible)}</Descriptions.Item>
                <Descriptions.Item label="Количество подчинённых">{request.subordinates_count || 0}</Descriptions.Item>
                <Descriptions.Item label="Руководитель">{request.supervisors || '—'}</Descriptions.Item>
                <Descriptions.Item label="Требуется переезд">{getBool(request.requires_relocation)}</Descriptions.Item>
                <Descriptions.Item label="Командировки">{getBool(request.requires_travel)}</Descriptions.Item>
                <Descriptions.Item label="Подробности командировок">{request.travel_details || '—'}</Descriptions.Item>
                <Descriptions.Item label="Необходимы права">{getBool(request.requires_license)}</Descriptions.Item>
                <Descriptions.Item label="Категории прав">
                    {Array.isArray(request.license_categories) && request.license_categories.length > 0
                        ? request.license_categories.join(', ')
                        : '—'}
                </Descriptions.Item>
                <Descriptions.Item label="Наличие авто">{getBool(request.requires_car)}</Descriptions.Item>
                <Descriptions.Item label="Образование">
                    {Array.isArray(request.education_levels) && request.education_levels.length > 0
                        ? request.education_levels.join(', ')
                        : '—'}
                </Descriptions.Item>
                <Descriptions.Item label="Уровень владения ПК">{request.computer_skills_level || '—'}</Descriptions.Item>
                <Descriptions.Item label="Навыки 1С">{request.skills_1c || '—'}</Descriptions.Item>
                <Descriptions.Item label="Другие программы">
                    {Array.isArray(request.software_skills)
                        ? renderObjectArray(request.software_skills, 'program', 'level')
                        : '—'}
                </Descriptions.Item>
                <Descriptions.Item label="Знание языков">
                    {Array.isArray(request.language_skills)
                        ? renderObjectArray(request.language_skills, 'language', 'level')
                        : '—'}
                </Descriptions.Item>
                <Descriptions.Item label="Опыт работы">{request.experience_description || '—'}</Descriptions.Item>
                <Descriptions.Item label="Проф. навыки">{request.professional_skills || '—'}</Descriptions.Item>
                <Descriptions.Item label="Личные качества">{request.personal_traits || '—'}</Descriptions.Item>
                <Descriptions.Item label="Ожидаемые результаты">{request.expected_results || '—'}</Descriptions.Item>
                <Descriptions.Item label="Учет и отчетность">{request.reporting_details || '—'}</Descriptions.Item>
                <Descriptions.Item label="Функциональные обязанности">{request.functional_responsibilities || '—'}</Descriptions.Item>
                <Descriptions.Item label="Задачи">{request.tasks || '—'}</Descriptions.Item>
                <Descriptions.Item label="Прочие условия">{request.other_conditions || '—'}</Descriptions.Item>
                <Descriptions.Item label="Предпочтительные компании">{request.preferred_companies || '—'}</Descriptions.Item>
                <Descriptions.Item label="Нежелательные компании">{request.unwanted_companies || '—'}</Descriptions.Item>
            </Descriptions>
            <style>{`
            .request-general-info .ant-descriptions-view table { table-layout: fixed; width: 100%; }
            .request-general-info .ant-descriptions-item-label { width: 33.333%; }
            .request-general-info .ant-descriptions-item-content { width: 66.667%; }
        `}</style>
        </div>
    );
};

export default RequestGeneralInfoTab;